import { useState } from 'react';
import { useQuery } from 'react-query';
import {useLocation, useParams} from 'react-router-dom';

import { apiService } from 'services/ApiService';
import styles from './SlotMachine.module.css';
import './styles.css';

import { SlotMachineGraphic, Pulse } from './components/Graphic';
import Video from './components/Video';
import Stars from './components/Stars';
import SlotMachineGame from './components/SlotMachineGame';

import logo from 'assets/games/theme-two/Logo.png';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';

export default function SlotMachine() {
  const { giveawayId } = useParams();
  const [bgMusicMuted, setBgMusicMuted] = useState(false);
  const [isWinnerGenerated, setIsWinnerGenerated] = useState(-1);
  const [isStartAllowed, setIsStartAllowed] = useState(false);
  const [email, setEmail] = useState('jackson.smit*********j@gmail.com');
  // const [currentPlace, setCurrentPlace] = useState('');
  // const [currentPrize, setCurrentPrize] = useState('');
  const [currentWinnerIndex, setCurrentWinnerIndex] = useState(-1);
  const [winCondition, setWinCondition] = useState(null);

  const { data: giveaway, isLoading: isGiveawayLoading } = useQuery({
    queryFn: async () => {
      if (!giveawayId) {
        return;
      }
      const { data } = await apiService.getGiveawayWinners({
        id: giveawayId,
      });

      return data;
    },
    queryKey: ['giveaway', giveawayId],
    refetchOnWindowFocus: false,
  });

  const getOrdinalSuffix = useCallback((num) => {
    if (typeof num !== 'number' || !Number.isInteger(num)) {
      return '';
    }

    if (num === 0) {
      return '';
    }

    let suffix = 'th';
    if (num % 100 < 11 || num % 100 > 13) {
      switch (num % 10) {
        case 1:
          suffix = 'st';
          break;
        case 2:
          suffix = 'nd';
          break;
        case 3:
          suffix = 'rd';
          break;
        default:
          break;
      }
    }

    return `${num}${suffix} prize `;
  }, []);

  const prize = useMemo(() => {
    if (!giveaway) {
      return;
    }
    return giveaway.prizes[currentWinnerIndex];
  }, [currentWinnerIndex, giveaway]);

  const currentPlace = useMemo(() => {
    return getOrdinalSuffix(currentWinnerIndex + 1);
  }, [currentWinnerIndex, getOrdinalSuffix]);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const startIndexParam = searchParams.get('startIndex');

  useEffect(() => {
    if (!giveaway) {
      return;
    }

    const allPrizes = giveaway.prizes || [];
    const allWinners = giveaway.winners || [];

    let initialIndex = startIndexParam !== null ? Number(startIndexParam) : allPrizes.length - 1;

    // if (
    //   giveaway.status === 'finished' ||
    //   allPrizes.length === allWinners.length
    // ) {
    //   setCurrentWinnerIndex(allPrizes.length - 1);
    // } else {
    //   // setCurrentWinnerIndex(allPrizes.length - allWinners.length - 1);
    //   setCurrentWinnerIndex(initialIndex);
    // }

    setCurrentWinnerIndex(initialIndex);
    // setPrize();
  }, [giveaway]);

  const addAstrickAfter3Char = useCallback((string) => {
    let newstr = '';
    for (var i in string) {
      if (i > 2 && i < string.length) {
        newstr += '*';
      } else {
        newstr += string[i];
      }
    }
    return newstr;
  }, []);

  const fetchData = useCallback(async () => {
    let data;
    const winners = giveaway.winners;
    const prizes = giveaway.prizes;
    if (giveaway.status === 'finished' || winners.length === prizes.length) {
      const winner = giveaway.winners[currentWinnerIndex];
      if (!winner) {
        return;
      }

      console.log(winner);
      data = {
        id: winner.id,
        isHidden: winner.isHidden,
        entry: {
          userEmail: winner?.prize?.winner?.email || winner.user?.email,
          userName: `${ winner?.prize?.winner?.firstName || winner.user?.firstName} ${(winner?.prize?.winner?.lastName || winner.user?.lastName)?.[0]}.`,
        },
      };
    } else {
      const payload = await apiService.generateWinner({ giveawayId });
      data = payload.data;
    }
    // console.log(currentWinnerIndex);
    // if (currentWinnerIndex === -1) {
    //   return;
    // }
    if (!data) {
      return;
    }
    if(data.isHidden){
      await apiService.revealGiveawayWinner({id: data.id});
    }


    let email_new = data.entry.userEmail;
    let emailSplit = email_new?.split('@') || [];
    let emailSplit_new = emailSplit?.[1]?.split('.') || [];
    let newstr = '';
    for (var i in emailSplit_new[0]) {
      if (i > 2 && i < emailSplit_new[0].length) {
        newstr += '*';
      } else {
        newstr += emailSplit_new[0][i];
      }
    }
    emailSplit_new[0] = newstr;
    let ewEmailData = emailSplit.length ?
      addAstrickAfter3Char(emailSplit[0]) +
      '@' +
      addAstrickAfter3Char(emailSplit[1]) : '';

    const username = data.entry.userName.toUpperCase();
    // winCondition = `${data.entry.userName}`;
    let spaces = Math.max(0, 12 - username.length);
    // Calculate half of the spaces needed for padding
    let leftSpaces = Math.floor(spaces / 2);
    let rightSpaces = spaces - leftSpaces;
    //     // Add the spaces to both sides of the string
    let winCondition =
      ' '.repeat(rightSpaces) + username + ' '.repeat(leftSpaces);
    setEmail(ewEmailData);
    setWinCondition(winCondition);
  }, [addAstrickAfter3Char, currentWinnerIndex, giveaway]);

  return (
    <>
      <div className={styles.slotMachineContainer}>
        <Stars />
        <Pulse />
        <SlotMachineGraphic isWinner={isWinnerGenerated} />
        <div className={styles.SlotMachineInnerContainer}>
          <img src={logo} alt="LMCT+" className={styles.SlotMachineLogo} />
          <Video bgMusicMuted={bgMusicMuted} />
          <SlotMachineGame
            place={currentPlace}
            prize={prize?.title || ''}
            email={email}
            isWinner={isWinnerGenerated}
            fetchData={fetchData}
            winCondition={winCondition}
            setIsWinnerGenerated={setIsWinnerGenerated}
            setCurrentWinnerIndex={setCurrentWinnerIndex}
            currentWinnerIndex={currentWinnerIndex}
            setWinCondition={setWinCondition}
          />
        </div>
      </div>
    </>
  );
}
